module.exports = __webpack_public_path__ + "static/media/icn_assistance.41b2cb58.svg";